import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de mínimos estándares
 */
class MinimosEstandaresRequest {
    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @return: Una lista de artículos.
     */
    static ListarMinimosEstandar(data) {
        return middleware.hasAuth(() => request.get(`api/minimos-estandares-articulo/`, {
            params: {
                sitios: data?.sitios?.toString(),
                articulo_id: data?.articulo_id
            }
        }))
    }

    /**
     * Llamada el endpoint de django para crear un mínimo
     * @param: data. objeto con información del mínimo
     * @return: Mensaje de éxito o error.
     */
    static NuevoMinimo(data) {
        return middleware.hasAuth(() => request.post(`api/minimos-estandares-articulo/`, data));
    }

    /**
     * Llamada el endpoint de django para editar un mínimo
     * @param: data. objeto con información del mínimo
     * @return: Mensaje de éxito o error.
     */
    static EditarMinimo(data) {
        return middleware.hasAuth(() => request.put(`api/minimos-estandares-articulo/${data.id}`, data));
    }

    /**
     * Llamada el endpoint de django para editar un mínimo masivo
     * @param: data. objeto con información del mínimo
     * @return: Mensaje de éxito o error.
     */
     static EditarMinimoMasivo(data) {
        return middleware.hasAuth(() => request.post(`api/minimos-estandares-articulo/update-masivo/`, data));
    }
}

export default MinimosEstandaresRequest;